module.exports = __webpack_public_path__ + "static/media/groundingAudio.3bb1524e.mp4";